import { Box, Typography } from '@mui/material';
import { FieldError } from 'react-hook-form';
import { EColors, getColor } from 'theme';
import { Tiptap } from './TipTap';
import { ToolbarInsertOption } from './TipTap/Toolbar';

type TextAreaFieldProps = {
    label?: string;
    error: FieldError | undefined;
    onChange: (text: string) => void;
    onBlur?: () => void;
    value: string | undefined;
    disabled?: boolean | undefined;
    required?: boolean;
    name: string;
    /** Extra toolbar buttons that insert literal text at the cursor (e.g. merge-field tokens). */
    insertOptions?: ToolbarInsertOption[];
};

export const RichTextEditorField = ({
    label,
    error,
    required = false,
    value,
    disabled,
    onChange,
    onBlur,
    insertOptions,
}: TextAreaFieldProps) => {
    return (
        <Box>
            {label && (
                <Box display="flex" gap={0.5} marginBottom={1}>
                    <Typography variant="body2" fontWeight={500}>
                        {label}
                    </Typography>
                    {required && (
                        <Typography color={getColor(EColors.pureBlack, 0.5)} fontWeight={500}>
                            *
                        </Typography>
                    )}
                </Box>
            )}

            <Tiptap
                editable={!disabled}
                description={value || ''}
                onChange={onChange}
                onBlur={() => onBlur?.()}
                error={!!error}
                insertOptions={insertOptions}
            />

            {!!error && (
                <Typography variant="body2" color={getColor(EColors.red)} fontWeight={500}>
                    {error.message}
                </Typography>
            )}
        </Box>
    );
};
